import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/${id}`);
    return response.data; // The user object
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

// export const updateUser = async (id, userData) => {
//   try {
//     const accountId = localStorage.getItem("account_id");
//     if (!accountId) throw new Error("Account ID not found in localStorage");

//     const payload = { ...userData, account_id: Number(accountId) };

//     const response = await axios.patch(`${API_BASE_URL}/user/${id}`, payload, {
//       headers: { "Content-Type": "application/json" },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error updating user:", error);
//     throw error.response?.data || { message: "Something went wrong" };
//   }
// };



export const updateUser = async (id, userData) => {
  try {
    const accountId = localStorage.getItem("account_id");
    if (!accountId) throw new Error("Account ID not found in localStorage");

    // const payload = {
    //   name: userData.name || '',
    //   email: userData.email || '',
    //   phone: userData.phone || '',
    //   address: userData.address || '',
    //   age: userData.age || '',
    //   gender: userData.gender || '',
    //   marital_status: userData.marital_status || '',
    //   account_id: Number(accountId)
    // };

    // console.log("Sending payload:", JSON.stringify(payload, null, 2));

    // const response = await axios.patch(
    //   `${API_BASE_URL}/user/${id}`,
    //   JSON.stringify(payload),
    //   {
    //     headers: {
    //       "Content-Type": "application/json"
    //     }
    //   }
    // );

    // ✅ Create FormData
    const formData = new FormData();
    const currentYear = new Date().getFullYear();

    formData.append("name", userData.name || "");
    formData.append("email", userData.email || "");
    formData.append("phone", userData.phone || "");
    formData.append("address", userData.address || "");
    formData.append(
      "age",
      userData.age
        ? currentYear - Number(userData.age)
        : ""
    ); formData.append("gender", userData.gender || "");
    formData.append("marital_status", userData.marital_status || "");
    formData.append("account_id", Number(accountId));

    // ✅ If photo exists, append it
    if (userData.photo instanceof File) {
      formData.append("photo", userData.photo);
    }

    // 🔍 Debug (optional)
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.patch(
      `${API_BASE_URL}/user/${id}`,
      formData
      // ❌ DO NOT set Content-Type manually
    );

    return response.data;
  } catch (error) {
    console.error("Error in updateUser:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error.response?.data || { error: error.message };
  }
};

export const updateFcmToken = async (userId, token) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/user/${userId}`,
      {
        fcm_token: token,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating FCM token:", error);
    return error.response?.data || { success: false, message: "Network error" };
  }
};






